import { IconButton } from '@sweep-io/sweep-design';
import { Close as CloseIcon } from '@sweep-io/sweep-design/dist/icons';
import { memo, useMemo } from 'react';

import {
  CreateEditDialogHeaderBase,
  CreateEditDialogHeaderBaseProps,
} from './CreateEditDialogHeaderBase';
import { Box } from '@mui/material';

export interface AutomationsCreateEditDialogHeaderProps extends CreateEditDialogHeaderBaseProps {
  onCancelClick?: () => any;
  showCancelButton?: boolean;
}

export const AutomationsCreateEditDialogHeader = memo(
  ({
    showCancelButton,
    onCancelClick,
    rightSideContent,
    ...restProps
  }: AutomationsCreateEditDialogHeaderProps) => {
    const _rightSideContent = useMemo(
      () => (
        <>
          {rightSideContent}
          {showCancelButton && (
            <Box sx={{ ml: -1 }}>
              <IconButton variant="flat" onClick={onCancelClick} data-dd-action-name="close">
                <CloseIcon />
              </IconButton>
            </Box>
          )}
        </>
      ),
      [rightSideContent, showCancelButton, onCancelClick],
    );

    return <CreateEditDialogHeaderBase {...restProps} rightSideContent={_rightSideContent} />;
  },
);

AutomationsCreateEditDialogHeader.displayName = 'AutomationsCreateEditDialogHeader';
